import { useState } from 'react';
import { About } from './About';
import { BiometricSetup } from './BiometricSetup';
import { QrScanner } from './QrScanner';
import { NotificationBell } from './NotificationBell';
import { usePushNotifications } from '../hooks/usePushNotifications';

const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
  || (navigator.maxTouchPoints > 0 && window.innerWidth < 768);

export function Header({ onLogout, activeView, onViewChange, token }) {
  const [showAbout, setShowAbout] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showBiometricSetup, setShowBiometricSetup] = useState(false);
  const [showQrScanner, setShowQrScanner] = useState(false);
  const { isSupported, isSubscribed, subscribe, unsubscribe } = usePushNotifications(token);

  const toggleNotifications = async () => {
    if (isSubscribed) {
      await unsubscribe();
    } else {
      await subscribe();
    }
  };

  const navItems = [
    { id: 'projects', icon: '🚦', label: 'Projects' },
    { id: 'status', icon: '📊', label: 'Status' },
    { id: 'fouten', icon: '🐞', label: 'Fouten' },
  ];

  return (
    <>
      <header style={{
        position: 'sticky',
        top: 0,
        zIndex: 40,
        backgroundColor: 'white',
        borderBottom: '1px solid #e5e7eb',
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <div style={{ flex: 1, display: 'flex', justifyContent: 'space-around' }}>
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '2px',
                padding: '6px 12px',
                border: 'none',
                borderRadius: '8px',
                backgroundColor: activeView === item.id ? '#dbeafe' : 'transparent',
                cursor: 'pointer',
                minWidth: '60px'
              }}
            >
              <span style={{ fontSize: '20px' }}>{item.icon}</span>
              <span style={{
                fontSize: '11px',
                color: activeView === item.id ? '#1d4ed8' : '#6b7280',
                fontWeight: activeView === item.id ? '600' : '400'
              }}>
                {item.label}
              </span>
            </button>
          ))}
        </div>

        <NotificationBell token={token} />

        <button
          onClick={() => setShowMenu(!showMenu)}
          style={{
            fontSize: '24px',
            padding: '8px',
            border: 'none',
            borderRadius: '8px',
            backgroundColor: showMenu ? '#f3f4f6' : 'transparent',
            cursor: 'pointer'
          }}
        >
          ☰
        </button>
      </header>

      {showMenu && (
        <div
          onClick={() => setShowMenu(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 50
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: '60px',
              right: '16px',
              backgroundColor: 'white',
              borderRadius: '8px',
              boxShadow: '0 10px 15px rgba(0,0,0,0.1)',
              overflow: 'hidden',
              minWidth: '160px'
            }}
          >
            {isSupported && (
              <button
                onClick={() => {
                  toggleNotifications();
                  setShowMenu(false);
                }}
                style={{
                  width: '100%',
                  padding: '12px 20px',
                  border: 'none',
                  backgroundColor: 'white',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '18px' }}>{isSubscribed ? '🔔' : '🔕'}</span>
                <span>{isSubscribed ? 'Meldingen uit' : 'Meldingen aan'}</span>
              </button>
            )}

            {isMobile && (
              <button
                onClick={() => {
                  setShowMenu(false);
                  setShowQrScanner(true);
                }}
                style={{
                  width: '100%',
                  padding: '12px 20px',
                  border: 'none',
                  backgroundColor: 'white',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '18px' }}>📷</span>
                <span>PC inloggen via QR</span>
              </button>
            )}

            {/* Biometrie is smartphone-only — zie authentication-methods.md
                §Desktop: "NIET tonen op desktop". */}
            {isMobile && (
              <button
                onClick={() => {
                  setShowMenu(false);
                  setShowBiometricSetup(true);
                }}
                style={{
                  width: '100%',
                  padding: '12px 20px',
                  border: 'none',
                  backgroundColor: 'white',
                  textAlign: 'left',
                  cursor: 'pointer',
                  display: 'flex',
                  gap: '12px',
                  alignItems: 'center'
                }}
              >
                <span style={{ fontSize: '18px' }}>🔐</span>
                <span>Face ID / Vingerafdruk</span>
              </button>
            )}

            <button
              onClick={() => {
                setShowMenu(false);
                setShowAbout(true);
              }}
              style={{
                width: '100%',
                padding: '12px 20px',
                border: 'none',
                backgroundColor: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                display: 'flex',
                gap: '12px',
                alignItems: 'center'
              }}
            >
              <span style={{ fontSize: '18px' }}>ℹ️</span>
              <span>About</span>
            </button>

            <div style={{ borderTop: '1px solid #e5e7eb' }}></div>

            <button
              onClick={() => {
                setShowMenu(false);
                onLogout();
              }}
              style={{
                width: '100%',
                padding: '12px 20px',
                border: 'none',
                backgroundColor: 'white',
                textAlign: 'left',
                cursor: 'pointer',
                display: 'flex',
                gap: '12px',
                alignItems: 'center',
                color: '#dc2626'
              }}
            >
              <span style={{ fontSize: '18px' }}>🚪</span>
              <span>Logout</span>
            </button>
          </div>
        </div>
      )}

      {showAbout && <About onClose={() => setShowAbout(false)} />}
      {showBiometricSetup && (
        <BiometricSetup token={token} onClose={() => setShowBiometricSetup(false)} />
      )}
      {showQrScanner && (
        <QrScanner
          token={token}
          onClose={() => setShowQrScanner(false)}
          onSetupBiometric={() => setShowBiometricSetup(true)}
        />
      )}
    </>
  );
}
